export const ChefWillBadge = ({ className = "h-32 w-32 sm:h-40 sm:w-40", id = "cw" }) => (
  <svg viewBox="0 0 200 200" className={`spin-slow ${className}`} aria-hidden="true">
    <defs>
      <path id={id} d="M100,100 m-76,0 a76,76 0 1,1 152,0 a76,76 0 1,1 -152,0" />
    </defs>
    <circle cx="100" cy="100" r="98" fill="#D0466F" />
    <circle cx="100" cy="100" r="92" fill="none" stroke="#fff" strokeWidth="2" strokeDasharray="5 6" />
    <text fill="#fff" fontSize="15" fontFamily="JetBrains Mono, monospace" fontWeight="600">
      <textPath href={`#${id}`} textLength="470" lengthAdjust="spacing">A RECIPE BY CHEF WILL · FLAPJACK · CULIFECT ·</textPath>
    </text>
    <circle cx="100" cy="100" r="46" fill="#fff" />
    <text x="100" y="98" textAnchor="middle" fontSize="13" fontFamily="JetBrains Mono, monospace" fontWeight="600" fill="#D0466F">CHEF</text>
    <text x="100" y="122" textAnchor="middle" fontSize="26" fontFamily="Shrikhand, Georgia, serif" fill="#D0466F">Will</text>
  </svg>
);
